import Vue from "vue"
import AppSettings from '@/appSettings';
import './assets/css/style.css';

import './register-router-hooks'
import './register-components'
import app from './components/app.vue'
import uiComponents from "ui-components";

const uiComponentsPlugin = (uiComponents as any).default || uiComponents;
Vue.use(uiComponentsPlugin);


import api from './api/dataSource/api/apiDataSource.plugin'
Vue.use(api, AppSettings.adminApiUrl, true);


import mainStore from './plugins/mainStore'
Vue.use(mainStore);

import cacheProvider from './plugins/cacheProvider'
Vue.use(cacheProvider);

import vSelect from "vue-select";
Vue.component('v-select', vSelect)

import domPlugin from './plugins/DomPlugin'
Vue.use(domPlugin);

// подключение popup с подтверждением
import dialogPlugin from "./plugins/Confirm/dialog/plugin.dialog"
Vue.use(dialogPlugin);
// подключение модуля copyPaste
import copyPaste from "./plugins/copyPaste/plugin.copyPaste"
Vue.use(copyPaste);
// подключение оповещений
import notificationPlugin from "./plugins/Confirm/notification/plugin.notification"
Vue.use(notificationPlugin);

import tooltipPlugin from "./plugins/tooltip.plugin"
Vue.use(tooltipPlugin);

if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        const reason = event.reason;
        console.error('Unhandled Promise Rejection', reason);
        const notification = (Vue as any).prototype.$notification;
        if (notification && typeof notification.error === 'function') {
            notification.error(reason);
        }
        event.preventDefault();
    });
}


// Подключение фильтров
import "./filters/moment.ts"
import "./filters/yesNo.ts"
import "./filters/translations.ts"
import "./filters/serverTypes.ts"
import "./filters/goal-survey.filter.ts"
import "./filters/meditation-filter.ts"


// import store from "./pages/map-routes/store/MapRoute"

const moment = require('moment')
moment.locale('ru');
Vue.use(require('vue-moment'),{
    moment
});

// import { Component } from "vue-property-decorator";
// Component.registerHooks([
//     "beforeRouteEnter",
//     "beforeRouteLeave",
//     "beforeRouteUpdate",
// ])



import router from './router'

import MiddlewareProcessor from "./middlewares/middlewareProcessor";
import EventBus from "@models/eventBus";
const middlewareProcessor = new MiddlewareProcessor(router);
// console.log('start vue');


const v = new Vue({
    el: "#app",
    router: router,
    // store: store,
    provide: () => ({
        eventBus: new EventBus()
    }),
    template: `<app/>`,
    components: { 
        app
    }
});




//console.dir(Vue)
